import { createContext, useContext } from "react";
import { sectionMeta, sectionNo } from "./sections";

const SecCtx = createContext("");
export const SubBadge = ({ className = "" }) => <span data-testid="sub-badge" data-sec={String(Number(useContext(SecCtx)))} className={`sub-badge ${className}`} />;

export const SectionShell = ({ id, description, children, action, alert, warn, titleAside }) => {
  const meta = sectionMeta(id);
  return (
    <SecCtx.Provider value={sectionNo(id)}>
    <section id={`admin-section-${id}`} data-testid={`admin-section-${id}`} data-warn={warn ? "1" : undefined} className={`scroll-mt-20 mb-10 admin-sec group/sec rounded-3xl transition-shadow ${warn ? "hover:ring-4 hover:ring-amber-400/70 hover:shadow-[0_0_0_8px_rgba(251,191,36,0.15)]" : ""}`}>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3 px-1">
        <div className="flex items-center gap-4">
          <span className="grid place-items-center w-16 h-16 rounded-2xl text-3xl font-bold tabular-nums border" style={{ backgroundColor: meta.tint, borderColor: meta.border }}>{sectionNo(id)}</span>
          <div>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2"><h2 className="font-serif font-bold text-4xl sm:text-5xl leading-tight">{meta.title}</h2>{titleAside}</div>
            {description && <p className="text-xs text-muted-foreground mt-1">{description}</p>}
          </div>
        </div>
        {action}
      </div>
      {alert}
      {children}
    </section>
    </SecCtx.Provider>
  );
};

export const SectionCard = ({ id, children, className = "", testId }) => {
  const meta = sectionMeta(id);
  return (
    <div data-testid={testId} className={`rounded-3xl border p-6 ${className}`} style={{ backgroundColor: meta.tint, borderColor: meta.border }}>
      {children}
    </div>
  );
};
